(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/components/ticket-skin-sunfeather.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/components/ticket-skin-sunfeather.js');
"use strict";

const {
  useCallback,
  useEffect,
  useRef,
  useState,
  useMemo,
  memo
} = React;
const {
  sunfeather
} = svs.tickets.play.utils.animations;
const TicketSkinImage = svs.tickets.play.components.TicketSkinImage;
function useSunfeatherAnimation(animation) {
  const ref = useRef(null);
  const intro = useMemo(() => (sunfeather.intro[animation] || sunfeather.intro.default).bind(null, ref), [ref, animation]);
  const select = useMemo(() => (sunfeather.select[animation] || sunfeather.select.default).bind(null, ref), [ref, animation]);
  const mouseEnter = useMemo(() => (sunfeather.mouseEnter[animation] || sunfeather.mouseEnter.default).bind(null, ref), [ref, animation]);
  const sibblingEnter = useMemo(() => (sunfeather.sibblingEnter[animation] || sunfeather.sibblingEnter.default).bind(null, ref), [ref, animation]);
  const mouseLeave = useMemo(() => (sunfeather.mouseLeave[animation] || sunfeather.mouseLeave.default).bind(null, ref), [ref, animation]);
  const outro = useMemo(() => (sunfeather.outro[animation] || sunfeather.outro.default).bind(null, ref), [ref, animation]);
  return {
    ref,
    intro,
    select,
    mouseEnter,
    sibblingEnter,
    mouseLeave,
    outro
  };
}
setGlobal('svs.tickets.play.components.TicketSkinSunfeather', memo(_ref => {
  let {
    gamePayed,
    hasFocus,
    number,
    handleGamePay,
    onHandleNumberChanged,
    numberOfTickets = 31,
    image,
    appTimeline = gsap.timeline(),
    chosen,
    onMouseEnter,
    onMouseLeave,
    hoverState,
    animation = ''
  } = _ref;
  const [loaded, setLoaded] = useState(false);
  const imgRef = useRef(null);
  const {
    ref: ticketSkinRef,
    intro,
    select,
    mouseEnter,
    sibblingEnter,
    mouseLeave,
    outro
  } = useSunfeatherAnimation(animation);
  useEffect(() => {
    if (imgRef.current) {
      setLoaded(true);
    }
  }, [imgRef.current]);

  useEffect(() => {
    if (loaded) {
      const tl = gsap.timeline();
      const unmount = intro(tl, number);
      if (chosen) {
        select(tl);
      }
      appTimeline.add(tl, 'gameReady');
      return () => {
        unmount && unmount();
        tl.kill();
      };
    }
  }, [loaded, number]);

  useEffect(() => {
    if (appTimeline.time() > (appTimeline.labels.gameReady || 0)) {
      if (chosen) {
        const tl = select();
        return () => {
          tl && tl.kill(ticketSkinRef.current);
        };
      }
      appTimeline.progress(1, false);
      mouseLeave(number);
    }
  }, [chosen]);

  useEffect(() => {
    if (!chosen && !gamePayed && loaded && appTimeline.time() > (appTimeline.labels.gameReady || 0)) {
      if (hoverState === 0) {
        mouseEnter(number);
      } else if (hoverState) {
        sibblingEnter(hoverState, number);
      } else {
        mouseLeave(number);
      }
    }
  }, [hoverState, loaded, number]);

  useEffect(() => {
    if (gamePayed) {
      outro();
    }
  }, [gamePayed]);
  const onClick = useCallback(() => {
    if (!gamePayed && chosen) {
      handleGamePay && handleGamePay();
    } else {
      onHandleNumberChanged(number);
    }
  }, [gamePayed, chosen, handleGamePay, onHandleNumberChanged, number]);
  const onHoverEnter = useCallback(() => !chosen && onMouseEnter(number), [chosen, onMouseEnter, number]);
  const onHoverLeave = useCallback(() => !chosen && onMouseLeave(number), [chosen, onMouseLeave, number]);
  return React.createElement("div", {
    className: "".concat(loaded ? 'image-loaded' : '', " ticket-skin-wrapper relative"),
    "data-ticket-number": number,
    onClick: onClick,
    ref: ticketSkinRef,
    style: {
      transform: 'scale(0)',
      zIndex: numberOfTickets - number,
      transformOrigin: '50% 100%',
      rotate: '0deg'
    }
  }, React.createElement("div", {
    className: "ticket-number absolute"
  }, number), React.createElement("div", {
    className: "".concat(hasFocus ? 'ticket-skin-focus' : ''),
    onMouseEnter: onHoverEnter,
    onMouseLeave: onHoverLeave,
    ref: imgRef
  }, React.createElement(TicketSkinImage, {
    image: image,
    number: number
  })));
}));

 })(window);